module.exports = __webpack_public_path__ + "img/38_66.68349175.png";